import api from "./api";
import TokenService from "./token.service";
import { shouldShowNavBars } from "./auth.logic";
class AuthService {
  login(username, password) {
    return api
      .post("/auth/signin", {
        username,
        password
      })
      .then(response => {        
        if (response.data.jwtToken) {
          TokenService.setUser(response.data);
        }
        return response.data;
      });
  }
  logout() {
    return api.post("/auth/signout").then(
      response => {
        TokenService.removeUser();
        TokenService.removeUserRoles();
        window.location.reload();
      }).catch((error) => {
        TokenService.removeUser();
        window.location.reload();
        TokenService.removeUserRoles();
      });
  }

  register(firstName, lastName, email, password, countryId) {
    return api.post("/auth/signup", {
      firstName,
      lastName,
      email,
      password,
      countryId
    });
  }

  getLoggedInUser() {
    return TokenService.getUser();
  }  

  getUserRoles() {
    return TokenService.getUserRoles();
  }

  shouldShowNavBars() {
    return shouldShowNavBars(this.getLoggedInUser(), window.location.pathname);
  }

}
export default new AuthService();